import React from 'react'
import { Link } from 'react-router-dom';
import "../../Styles/NavBar/NavBar.css"
function AdminNavBar() {
  return (
    <div className="navBar flexBox">
      <Link to="/admin/" className="logoContainer flexBox">
        <img src={process.env.PUBLIC_URL + "/images/Logo.png"} alt="Logo" />
        <h1>
          <span>Darshan</span> Naik
        </h1>
      </Link>
      <div className="menuContainer flexBox">
        <Link to="/admin/">Home</Link>
        <Link to="/admin/about">About</Link>
        <Link to="/admin/projects">Projects</Link>
        <Link to="/admin/skills">Skills</Link>
      </div>
    </div>
  );
}

export default AdminNavBar;
